import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { createNewRow } from "../../lib/utils";
import { addNewLoopEntry } from "../../store/actions/client";
import { clientEntriesSelector } from "../../store/selectors/clientEntries";
import { AdvancedLoopScreenItem } from "./AdvancedLoopScreenItem";
import { getSubSheetScreens } from "../../lib/sheets";
const createNewLoopEntry = (keyField, subSheetScreens) => {
  let allEntries = [keyField];
  subSheetScreens.forEach(({
    entries
  }) => {
    if (entries?.length) {
      allEntries = [...allEntries, ...entries];
    }
  });
  const newLoopEntry = createNewRow(allEntries);
  return newLoopEntry;
};
export const EditableAdvancedLoopScreen = ({
  keyField,
  sheet
}) => {
  const dispatch = useDispatch();
  const clientEntries = useSelector(clientEntriesSelector);
  const [loopItems, setLoopItems] = useState([]);
  const subSheetScreens = getSubSheetScreens(sheet);
  const renderNewLoopEntry = () => {
    const {
      activeRowGuid,
      entries
    } = createNewLoopEntry(keyField, subSheetScreens);
    dispatch(addNewLoopEntry({
      activeRowGuid,
      entries
    }));
    setLoopItems([...loopItems, activeRowGuid]);
  };
  useEffect(() => {
    // Returns existing loop screen entries, if any
    const getExistingLoopScreenEntries = () => {
      const sheetIds = [`${keyField.sheet_id}`];
      subSheetScreens.forEach(({
        subSheet
      }) => sheetIds.push(`${subSheet.id}`));
      return clientEntries.filter(entry => sheetIds.includes(`${entry.sheet_id}`) && entry.rowGuid);
    };
    const existingLoopScreenEntries = getExistingLoopScreenEntries();
    if (existingLoopScreenEntries.length) {
      // Render existing loop screen entries
      const uniqueRowGuids = new Set(existingLoopScreenEntries.map(({
        rowGuid
      }) => rowGuid));
      setLoopItems(Array.from(uniqueRowGuids));
    }
  }, []);
  return <div className="advanced-loop-screen--container">
      {loopItems.map(loopItemRowGuid => <AdvancedLoopScreenItem key={`advanced-loop-screen--loop-item-${loopItemRowGuid}`} keyField={keyField} allowDuplicates={sheet.allow_duplicate} subSheetScreens={subSheetScreens} rowGuid={loopItemRowGuid} loopItems={loopItems} setLoopItems={setLoopItems} />)}
      <div className="advanced-loop-screen--loop-item-add-item-container">
        <button type="button" className="foundry--button button--contained button--active" onClick={() => renderNewLoopEntry()}>
          <FontAwesomeIcon className="preview--loop--addItem" icon={faPlus} />
          <span className="button--label">Add Item</span>
        </button>
      </div>
    </div>;
};